import React, { useState } from 'react';
import AvailabilitySettings from './AvailabilitySettings.tsx';

interface AvailabilitySettingsTriggerProps {
  className?: string;
  label?: string;
  disabled?: boolean;
}

const AvailabilitySettingsTrigger: React.FC<AvailabilitySettingsTriggerProps> = ({
  className = 'btn btn-secondary reservo-availability-trigger',
  label = 'Horário de funcionamento',
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={className}
        disabled={disabled}
        onClick={() => setIsOpen(true)}
      >
        {label}
      </button>

      {isOpen && (
        <AvailabilitySettings onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default AvailabilitySettingsTrigger;
